import React from 'react';

import { RightSidebar } from "src/pages/_partials/Layout";
import { RateInterface } from "src/store/callrecorder/ratesSlice";
import { useAppSelector } from "src/store/hooks";
import { selectProviderEntities } from "src/store/callrecorder/providersSlice";
import RowInfo from "src/componets/RowInfo";
import { formattedDate } from "src/helpers/DateHelpers";

const _SidebarShow = ({ record }: { record: RateInterface | undefined }) => {
  const providerEntities = useAppSelector(selectProviderEntities);

  const renderDetails = () => {
    if (!record) {
      return null;
    }

    const provider = providerEntities[record.provider_id];

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='Provider' right={provider ? provider.name : `#${record.provider_id}`} />
          <RowInfo left='Prefix' right={record.prefix} />
          <RowInfo left='Prefix Len' right={record.prefix_len} />
          <RowInfo left='Src Prefix' right={record.src_prefix || '—'} />
          <RowInfo left='Src Prefix Len' right={record.src_prefix_len} />
          <RowInfo left='Country' right={record.iso || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Pricing</h6>

          <RowInfo left='Cost/Min' right={record.cost_per_min} />
          <RowInfo left='Raw Cost' right={record.raw_cost || '—'} />
          <RowInfo left='Currency' right={record.currency_id ? `#${record.currency_id}` : '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Notes</h6>

          <RowInfo left='Notes' right={record.notes || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Dates</h6>

          <RowInfo left='Last Synced' right={record.last_synced_at ? formattedDate(record.last_synced_at).dateTime : '—'} />
          <RowInfo left='Created' right={formattedDate(record.created_at).dateTime} />
          <RowInfo left='Updated' right={formattedDate(record.updated_at).dateTime} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>RATE DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
